var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"sounds-send-button",class:_vm.recording?'sounds-send-start':'sounds-send-def',on:{"mousedown":_vm.startRecording,"mouseup":_vm.stopRecording}},[_vm._m(0),_c('span',[_vm._v(_vm._s(_vm.recording?'松开发送':'按住说话'))])])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"sounds-button-icon"},[_c('i',{staticClass:"el-icon-microphone"})])
}]

export { render, staticRenderFns }